import React from "react";
import EntityForm from "@/modules/entity/forms";
import get from "lodash/get";
import Form from "./form";

const Update = ({closeCardForm, selected, onSuccess, leadId}) => {
    const id = get(selected && selected, "id");
    const taskData = selected;

    const [statusCheck, setStatusCheck] = React.useState(taskData.status);

    return (
        <EntityForm.Main
            method="put"
            entity="services"
            name={`all`}
            normalizeData={(data) => data}
            updateData={true}
            id={id}
            url={`/employee/tasks/${leadId}/${id}`}
            onSuccess={(updatedTask) => {
                closeCardForm();
                if (onSuccess) {
                    onSuccess(updatedTask);
                }
            }}
            params={{
                extra: {
                    modelable_id: leadId,
                    modelable_type: 'lead',
                }
            }}
            fields={[
                {
                    name: "content",
                },
                {
                    name: "status",
                    value: taskData.status || null,
                },
                {
                    name: "scheduled_time",
                    onSubmitValue: (value) => {
                        if (!value) return;
                        const date = new Date(value);
                        const utcDate = new Date(
                            Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
                        );
                        return utcDate.toISOString();
                    },
                },
                {
                    name: "updated_at",
                },
                
                
                
                
                
                
            ]}
        >
            {({isSubmitting, values}) => {
                return (
                    <div className="product-form p-2">
                        <Form values={values} setStatusCheck={setStatusCheck}/>
                        <div className="product-form__footer">
                            <button
                                type="submit"
                                className={`d-btn d-btn-secondary !justify-center ${
                                    isSubmitting ? "--loading" : ""
                                }`}
                                disabled={isSubmitting}
                            >
                                Сохранить
                            </button>
                        </div>
                    </div>
                );
            }}
        </EntityForm.Main>
    );
};

export default Update;
